export default __webpack_public_path__ + "static/logo-white-ed960274d27aa961c3506251129b210c.svg";